// 用于校验图片参数
function getCheckConfigs() {
  /**
   * text 格式图片校验
   *
   * @param {boolean} hasCombin - 是否有独立跟随
   */
  const textCheck = (hasCombin = false, checkInvalidImage = false) => {
    const checkArr = hasCombin
      ? [
          {
            fieldPath: ['text', 'image', 'font_images', 0, 'images'],
            isList: true,
            // workaround 这块结构待优化以适应多条件组合场景
            when: [
              {
                fieldPath: ['combin'],
                value: 'single'
              },
              {
                fieldPath: ['text', 'image', 'system_font'],
                value: undefined // 当该路径无值时进行校验
              }
            ]
          }
        ]
      : [
          {
            fieldPath: ['text', 'image', 'font_images', 0, 'images'],
            isList: true,
            when: {
              fieldPath: ['text', 'image', 'system_font'],
              value: undefined // 当该路径无值时进行校验
            }
          }
        ]
    if (checkInvalidImage) {
      checkArr.push({
        fieldPath: ['text', 'image', 'invalid_image']
      })
    }

    return checkArr
  }

  const pointerProgressCheck = [
    {
      fieldPath: ['pointer', 'image']
    }
  ]

  const checkConfigs = {
    common: {
      // text
      current: textCheck(),
      target: textCheck(),
      text: textCheck(),
      // 图标
      icon: [
        {
          fieldPath: ['image']
        }
      ],
      pointer_progress: pointerProgressCheck,
      image_progress: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ]
    },
    date: {
      year: textCheck(),
      month: textCheck(true),
      day: textCheck(true)
    },
    week: {
      text: [
        {
          fieldPath: ['text', 'image', 'font_images', 0, 'images']
        }
      ]
    },
    digital_clock: {
      hour: textCheck(),
      minute: textCheck(true),
      second: textCheck(true),
      am: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ],
      pm: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ]
    },
    alarm_clock: {
      hour: textCheck(),
      minute: textCheck(true),
      second: textCheck(true),
      am: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ],
      pm: [
        {
          fieldPath: ['images', '0', 'image', 'url']
        },
        {
          fieldPath: ['images', '1', 'image', 'url']
        }
      ],
      no_icon: [{ fieldPath: ['image'] }]
    },
    animation: {
      first: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ],
      second: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ],
      third: [
        {
          fieldPath: ['images'],
          isList: true
        }
      ]
    },
    shortcut: {
      music: [{ fieldPath: ['image'] }],
      woman_health: [{ fieldPath: ['image'] }],
      count_down: [{ fieldPath: ['image'] }],
      stop_watch: [{ fieldPath: ['image'] }],
      pomodoro: [{ fieldPath: ['image'] }],
      sport: [{ fieldPath: ['image'] }],
      // calculator: [{ fieldPath: ['image'] }],
      voice: [{ fieldPath: ['image'] }]
    },
    system: {
      dnd: [
        {
          fieldPath: ['image']
        }
      ],
      lock: [
        {
          fieldPath: ['image']
        }
      ],
      clock: [
        {
          fieldPath: ['image']
        }
      ],
      disconnect: [
        {
          fieldPath: ['image']
        }
      ]
    },
    heart_rate: {
      text: textCheck(false, true)
    },
    distance: {
      text: [
        {
          fieldPath: ['text', 'image', 'point_image', 'url']
        }
      ]
    },
    background: [
      {
        fieldPath: ['image'],
        when: {
          fieldPath: ['type'],
          value: 'image'
        }
      }
    ],
    analog_clock: {
      hour: [
        {
          fieldPath: ['pointer', 'image']
        }
      ],
      minute: [
        {
          fieldPath: ['pointer', 'image']
        }
      ],
      second: [
        {
          fieldPath: ['pointer', 'image']
        }
      ]
    },
    weather: {
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 26,
          isList: true
        }
      ]
    },
    temperature: {
      current: textCheck(false, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ]),
      high: textCheck(false, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ]),
      low: textCheck(true, true).concat([
        {
          fieldPath: ['text', 'image', 'negative_image', 'url']
        }
      ])
    },
    sunrise: {
      text: textCheck(false, true)
    },
    sunset: {
      text: textCheck(false, true)
    },
    pai: {
      weekly: textCheck()
    },
    aqi: {
      text: textCheck(false, true),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 6,
          isList: true
        }
      ]
    },
    uvi: {
      text: textCheck(false, true),
      image_progress: [
        {
          fieldPath: ['images'],
          listSize: 5,
          isList: true
        }
      ]
    },
    humidity: {
      text: textCheck(false, true)
    }
  }

  return checkConfigs
}

export default getCheckConfigs
